<template>
  <div class="row">
    <div class="col-md">
      <div class="portlet" v-if="isBusy">
        <div class="d-flex align-items-center">
          <b-spinner small class="mx-2"></b-spinner>Wczytuje...
        </div>
      </div>
      <div class="portlet" v-else>
        <div class="portlet-head" :style="setProjectsCollors(parent_color)">
          <h3 v-if="parent_id" class="project-createform">
            Dodaj podbudowe do projektu:
            <router-link
              :to="'/construction/' + parent_id + '/'"
              class="project-name"
              >{{ parent_name }}</router-link
            >
          </h3>
          <h3 v-else>Dodaj Budowę</h3>
        </div>
        <ValidationObserver
          ref="constructionForm"
          tag="form"
          @submit.prevent="onSubmit"
          class="form-horizontal"
          id="constructionForm"
        >
          <div class="portlet-body">
            <div class="row">
              <div class="col-md-6">
                <div class="section-title">Informacje o budowie:</div>
                <ConstructionFormInfo
                  :form="this.localInfo"
                  :isMainProject="isMainProject"
                  v-on:toggleMainProject="toggleMainProject"
                />
              </div>
              <div class="col-md-6" v-if="isMainProject === false">
                <div class="section-title">Podwykonawcy:</div>
                <ConstructionSubcontractorsForm
                  :subcontractors="this.subcontractors"
                  v-on:onchange="this.handlePositionChange"
                />
              </div>
            </div>
          </div>
          <div class="portlet-footer">
            <div class="row">
              <div class="col-lg-3"></div>
              <div class="col-lg-6">
                <button
                  type="submit"
                  class="btn btn-primary btn-wide btn-block"
                >
                  Zapisz
                </button>
              </div>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { setProjectsCollors } from "@/services/helpers";
import ConstructionSubcontractorsForm from "@/components/construction/ConstructionSubcontractorsForm";
import ConstructionFormInfo from "@/components/construction/ConstructionFormInfo";

export default {
  name: "TheConstructionForm",
  components: {
    ConstructionFormInfo,
    ConstructionSubcontractorsForm,
  },
  data() {
    return {
      isBusy: false,
      parent_id: false,
      parent_name: false,
      parent_color: false,
      isMainProject: false,
      subcontractors: [],
      localInfo: {},
    };
  },
  computed: {
    ...mapGetters("user", ["getRole", "hasAccess"]),
    ...mapGetters("construction", ["info"]), //Info to dane parent projektu
  },
  created() {
    this.parent_id = this.$route.params.id
      ? parseInt(this.$route.params.id)
      : false;
    if (this.parent_id) {
      this.isBusy = true;
      this.loadSimpleInfo(this.parent_id)
        .then((item) => {
          this.parent_name = item.name;
          this.parent_color = item.color;
          this.localInfo.parent_id = this.parent_id;
          this.localInfo.company_id = item.company_id;
          this.isMainProject = false;
        })
        .finally(() => {
          this.isBusy = false;
        });
    }
  },
  mounted() {},
  methods: {
    ...mapActions("projectslist", ["create"]),
    ...mapActions("construction", ["loadSimpleInfo"]),
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onSubmit() {
      this.$refs.constructionForm.validate().then((success) => {
        if (!success) {
          return;
        }
        this.$Progress.start();
        if (this.isMainProject === false) {
          this.localInfo.color = null;
        }
        let query = {
          data: this.localInfo,
          subcontractors: this.isMainProject ? [] : this.subcontractors,
        };
        this.create(query)
          .then((response) => {
            this.$router.push({ path: `/construction/${response.id}` });
          })
          .catch((error) => {
            this.$refs.constructionForm.setErrors(error.response.data.fields);
          });
      });
    },
    handlePositionChange(newList) {
      this.subcontractors = newList;
    },
    toggleMainProject(checked) {
      this.isMainProject = checked;
    },
    setProjectsCollors,
  },
};
</script>